import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const CITIES = ['Córdoba', 'Buenos Aires', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe'];
const NAMES = ['Maria', 'Sofía', 'Lucía', 'Valentina', 'Martina', 'Camila', 'Julieta', 'Paula'];
export function SalesPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Show popup every 15-30 seconds
    const showRandomPopup = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name,
        city
      });
      setVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showRandomPopup, 5000);
    // Recurring interval
    const interval = setInterval(showRandomPopup, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl p-4 border-l-4 border-green-500 flex items-center gap-3 max-w-xs animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-4">
      <div className="bg-green-100 p-2 rounded-full" data-id="element-5">
        <CheckCircle className="w-6 h-6 text-green-600" data-id="element-6" />
      </div>
      <div data-id="element-7">
        <p className="text-sm font-bold text-gray-900" data-id="element-8">
          {data.name} de {data.city}
        </p>
        <p className="text-xs text-gray-600" data-id="element-9">acaba de comprar el MegaPack</p>
        <p className="text-xs text-gray-400 mt-1" data-id="element-10">Hace unos instantes</p>
      </div>
    </div>;
}